<template>
  <core-view class="flex-column pt-0" fill-height>
    <!-- Botão Novo Fixo no Topo -->
    <div class="divnovo mt-0 elevation-2">
      <v-btn height="45" color="green" class="botaoinferior" @click="$_novoFormulario">
        <v-icon left>mdi-plus</v-icon>
        Novo
      </v-btn>
    </div>

    <div class="wrapper">

      <!-- Indicador de Carregamento -->
      <div v-if="loading" class="text-center my-6">
        <v-progress-circular indeterminate color="green"></v-progress-circular>
      </div>

      <!-- Estado Vazio (Nenhum registro) -->
      <!-- <div v-else-if="itens.length === 0" class="sem-registro">
        <v-icon large color="grey lighten-1">mdi-wrench-outline</v-icon>
        <p class="mt-2 text-subtitle-1 grey--text text--darken-1">
          Nenhuma manutenção encontrada.
        </p>
        <v-btn
          v-if="temFiltrosAtivos"
          small
          outlined
          color="primary"
          class="mt-2 text-none"
          @click="$_limparFiltros"
        >
          Limpar filtros
        </v-btn>
      </div> -->

      <!-- Lista de Cards -->
      <div v-else class="cards-container">
        <v-card
          v-for="item in itens"
          :key="item.id"
          class="card-manutencao"
          elevation="2"
          @click="$_toggleExpand(item.id)"
          ripple
        >
          <!-- Cabeçalho do Card -->
          <div class="card-header">
            <!-- 1ª Linha: ID e Veículo (veifrota - veiplaca - veimarca) -->
            <div class="d-flex justify-space-between align-center">
              <div class="d-flex align-center flex-wrap min-w-0 mr-2">
                <!-- <v-icon
                  small
                  :color="item.sincronizado ? 'green darken-1' : 'amber darken-2'"
                  class="mr-1"
                  :title="item.sincronizado ? 'Sincronizado com a nuvem' : 'Salvo localmente (pendente de envio)'"
                >
                  {{ item.sincronizado ? 'mdi-cloud-check' : 'mdi-cloud-sync-outline' }}
                </v-icon> -->
                <span class="item-id font-weight-bold mr-2">
                  #{{ item.id }}
                </span>
                <span v-if="$_formatarFrotaTitulo(item)" class="frota-titulo font-weight-bold mr-2">
                  {{ $_formatarFrotaTitulo(item) }}
                </span>
              </div>

              <div class="flex-shrink-0">
                <v-icon small color="grey darken-2">
                  {{ $_isExpanded(item.id) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
              </div>
            </div>

            <!-- 2ª Linha: Data e Evento -->
            <div class="d-flex justify-space-between align-center mt-1">
              <span class="data-texto text-caption grey--text text--darken-1">
                {{ $_formataData(item.dataHora || item.data) }}
              </span>

              <!-- <v-chip
                v-if="$_getEventoNome(item)"
                x-small
                color="green lighten-5"
                class="green--text text--darken-3 font-weight-medium"
              >
                {{ $_getEventoNome(item) }}
              </v-chip> -->
            </div>
          </div>

          <!-- Detalhes do Card (Ao expandir) -->
          <v-expand-transition>
            <div v-show="$_isExpanded(item.id)">
              <v-divider></v-divider>
              <div class="card-detalhes" @click.stop>
                <div class="info-row" v-if="$_getOperador(item)">
                  <span class="info-label">Operador:</span>
                  <span class="info-valor">{{ $_getOperador(item) }}</span>
                </div>

                <div class="info-row" v-if="$_getExecutor(item)">
                  <span class="info-label">Executor:</span>
                  <span class="info-valor">{{ $_getExecutor(item) }}</span>
                </div>

                <div class="info-row" v-if="item.tipoManutencao">
                  <span class="info-label">Manutenção:</span>
                  <span class="info-valor">{{ item.tipoManutencao }}</span>
                </div>

                <div class="info-row" v-if="$_getPropriedade(item)">
                  <span class="info-label">Propriedade:</span>
                  <span class="info-valor">{{ $_getPropriedade(item) }}</span>
                </div>

                <div class="info-row" v-if="$_getOdometro(item)">
                  <span class="info-label">Odômetro / Horímetro:</span>
                  <span class="info-valor">{{ $_getOdometro(item) }}</span>
                </div>

                <div class="info-row" v-if="$_getAtividade(item)">
                  <span class="info-label">Atividade:</span>
                  <span class="info-valor">{{ $_getAtividade(item) }}</span>
                </div>

                <div class="info-row" v-if="item.descricao || item.descricaoEvento">
                  <span class="info-label">Descrição:</span>
                  <span class="info-valor">{{ item.descricaoEvento || item.descricao }}</span>
                </div>

                <div class="info-row info-obs" v-if="item.observacao">
                  <span class="info-label">Observação:</span>
                  <span class="obs-box">{{ item.observacao }}</span>
                </div>

                <!-- Lista de Itens / Peças com Simplebar -->
                <div class="itens-secao mt-2" v-if="item.itens && item.itens.length > 0">
                  <div class="itens-secao-header d-flex align-center justify-space-between mb-1">
                    <span class="info-label font-weight-bold d-flex align-center">
                      <v-icon small color="grey darken-2" class="mr-1">mdi-tools</v-icon>
                      Itens
                    </span>
                    <v-chip x-small color="grey lighten-2" class="font-weight-medium">
                      {{ item.itens.length }} {{ item.itens.length === 1 ? 'item' : 'itens' }}
                    </v-chip>
                  </div>

                  <simplebar
                    class="itens-simplebar-scroll"
                    :autoHide="false"
                  >
                    <div class="itens-lista">
                      <div
                        v-for="(peca, pIndex) in item.itens"
                        :key="pIndex"
                        class="item-peca-card"
                      >
                        <div class="d-flex align-center justify-space-between">
                          <div class="d-flex align-center flex-wrap min-w-0 mr-2">
                            <v-chip
                              x-small
                              class="mr-2 font-weight-bold flex-shrink-0"
                            >
                              {{ peca.tipo || 'Peça' }}
                            </v-chip>
                            <span class="item-peca-desc font-weight-medium">
                              {{ $_obterTextoItem(peca) }}
                            </span>
                          </div>
                          <span class="item-peca-qtd flex-shrink-0 font-weight-bold text-caption grey--text text--darken-2">
                            {{ peca.quantidade }} {{ peca.unidade || 'UN' }}
                          </span>
                        </div>

                        <div
                          v-if="peca.valorUnitario || peca.valorTotal"
                          class="d-flex justify-end text-caption grey--text text--darken-1 mt-1"
                        >
                          <span v-if="peca.valorUnitario" class="mr-2">
                            Unit: {{ $_formataMoeda(peca.valorUnitario) }}
                          </span>
                          <span v-if="peca.valorTotal" class="font-weight-bold green--text text--darken-2">
                            Total: {{ $_formataMoeda(peca.valorTotal) }}
                          </span>
                        </div>

                        <div
                          v-if="peca.observacao"
                          class="text-caption grey--text text--darken-2 mt-1"
                          style="word-break: break-word; white-space: pre-wrap; font-size: 11px;"
                        >
                          <span class="font-weight-medium">Obs:</span> {{ peca.observacao }}
                        </div>
                      </div>
                    </div>
                  </simplebar>
                </div>

              </div>
            </div>
          </v-expand-transition>

          <!-- Ações do Card (Enviar e Editar) -->
          <v-divider></v-divider>
          <div class="card-acoes d-flex justify-end align-center px-3 py-2" @click.stop>
            <v-btn
              small
              outlined
              color="primary"
              class="mr-2 text-none font-weight-medium btn-acao"
              @click.stop="$_editar(item)"
            >
              <v-icon left small>mdi-pencil-outline</v-icon>
              Editar
            </v-btn>

            <v-btn
              small
              color="primary"
              class="text-none font-weight-medium btn-acao"
              :loading="enviandoId === (item.idLocal || item.id)"
              :disabled="enviandoId !== null"
              @click.stop="$_enviar(item)"
            >
              <v-icon left small>mdi-cloud-upload-outline</v-icon>
              Enviar
            </v-btn>

          </div>
        </v-card>
      </div>
    </div>
  </core-view>
</template>

<script>
import moment from 'moment-timezone';
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';
import CoreView from '@/components/core/view/Index.vue';
import db from '@/plugins/dexie';
import { MANUTENCAO_STORAGE, ROTA_STORAGE } from '@/constants/STORAGE';
import { MANUTENCAO_QUERIES } from '@/constants/QUERY_FILTERS';
import { getQueryValue, setQueryValue } from '@/services/query-string';
import geraData from '@/utils/geradata';
import errorHandler from '@/utils/error-handler';
import { testarConexaoApi } from '@/utils/isonline';
import enviaMovimentacaoVeiculo from '@/utils/local/enviaMovimentacaoVeiculo';
import enviaItemMovimentacaoVeiculo, { deletaItemMovimentacaoVeiculo } from '@/utils/local/enviaItemMovimentacaoVeiculo';

export default {
  name: 'ViewManutencaoFrota',

  components: {
    CoreView,
    simplebar,
  },

  data() {
    return {
      loading: false,
      enviandoId: null,
      expandedIds: [],

      todosItens: [],
      itens: [],
    };
  },

  computed: {
    temFiltrosAtivos() {
      const hoje = geraData(new Date(), 'YYYY-MM-DD');
      const storageFrom = sessionStorage.getItem(MANUTENCAO_STORAGE.createdFrom);
      const storageBefore = sessionStorage.getItem(MANUTENCAO_STORAGE.createdBefore);
      const storagePlaca = sessionStorage.getItem(MANUTENCAO_STORAGE.placa);

      const from = getQueryValue(MANUTENCAO_QUERIES.createdFrom, storageFrom || null);
      const before = getQueryValue(MANUTENCAO_QUERIES.createdBefore, storageBefore || null);
      const placa = getQueryValue(MANUTENCAO_QUERIES.placa, storagePlaca || null);
      const dataDiferenteDeHoje = (from && from !== hoje) || (before && before !== hoje);

      return Boolean(
        dataDiferenteDeHoje
        || (placa && placa !== 'null' && placa !== 'undefined'),
      );
    },
  },

  methods: {
    $_toggleExpand(id) {
      const index = this.expandedIds.indexOf(id);
      if (index > -1) {
        this.expandedIds.splice(index, 1);
      } else {
        this.expandedIds.push(id);
      }
    },

    $_isExpanded(id) {
      return this.expandedIds.includes(id);
    },

    $_formatarFrotaTitulo(item) {
      if (!item) return '';

      const sanitize = (val) => {
        if (val == null) return '';
        const str = String(val).trim();
        const lower = str.toLowerCase();
        if (lower === 'veículo' || lower === 'veiculo' || lower === 'frota não informada' || lower === '-') {
          return '';
        }
        return str;
      };

      const vei = item.veiculo || (typeof item.frota === 'object' && item.frota !== null ? item.frota : {});
      let frota = sanitize(item.veifrota) || sanitize(vei && vei.veifrota);
      const placa = sanitize(item.veiplaca) || sanitize(vei && vei.veiplaca) || sanitize(item.placa);
      const marca = sanitize(item.veimarca) || sanitize(vei && vei.veimarca) || sanitize(item.marca);

      // Se a frota for idêntica à marca, evita duplicidade
      if (frota && marca && frota.toLowerCase() === marca.toLowerCase()) {
        frota = '';
      }

      const partes = [];
      if (frota) partes.push(frota);
      if (placa) partes.push(placa);
      if (marca) partes.push(marca);

      if (partes.length === 0) {
        const desc = sanitize(vei && vei.veidescricao) || sanitize(item.veidescricao);
        return desc || '';
      }

      return partes.join(' - ');
    },

    $_obterIdProdutoItem(item) {
      if (!item) return null;
      if (item.imvidproduto !== undefined && item.imvidproduto !== null && item.imvidproduto !== '') {
        return item.imvidproduto;
      }
      return item.produto?.proidproduto || item.produto?.id || null;
    },

    $_obterProcodigoItem(item) {
      if (!item) return '';
      return item.procodigo || item.produto?.procodigo || '';
    },

    $_obterTextoItem(peca) {
      if (!peca) return '';
      const codigo = this.$_obterProcodigoItem(peca);
      const desc = peca.descricao || peca.imvdescricaoproduto || 'Peça / Item';
      if (codigo) {
        const regexCodigo = new RegExp(`^${String(codigo).replace(/[.*+?^${}()|[\\]\\]/g, '\\$&')}\\s*-\\s*`, 'i');
        const descLimpa = desc.replace(regexCodigo, '').trim();
        return `${codigo} - ${descLimpa}`;
      }
      return desc;
    },

    $_obterNomeProduto(produtoObj, descricaoTexto) {
      if (produtoObj && produtoObj.prodescricaoOriginal) {
        return String(produtoObj.prodescricaoOriginal).trim();
      }

      const texto = String(descricaoTexto || produtoObj?.prodescricao || produtoObj?.descricao || '').trim();
      if (!texto) return '';

      const codigo = String(produtoObj?.procodigo || '').trim();
      if (codigo) {
        const regexCodigo = new RegExp(`^${codigo.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\s*-\\s*`, 'i');
        if (regexCodigo.test(texto)) {
          return texto.replace(regexCodigo, '').trim();
        }
      }

      if (produtoObj && produtoObj.prodescricao) {
        return String(produtoObj.prodescricao).trim();
      }

      return texto;
    },

    $_getFrotaNome(item) {
      return this.$_formatarFrotaTitulo(item);
    },

    $_getPlaca(item) {
      if (!item) return '';
      if (item.veiplaca) return item.veiplaca;
      if (item.placa) return item.placa;
      if (typeof item.frota === 'object' && item.frota !== null) {
        return item.frota.veiplaca || '';
      }
      return '';
    },

    $_getOperador(item) {
      if (!item || !item.operador) return '';
      if (typeof item.operador === 'object') {
        return item.operador.pesnome || item.operador.pesnomefantasia || '';
      }
      return String(item.operador);
    },

    $_getExecutor(item) {
      if (!item || !item.executor) return '';
      if (typeof item.executor === 'object') {
        return item.executor.pesnome || item.executor.pesnomefantasia || '';
      }
      return String(item.executor);
    },

    $_getPropriedade(item) {
      if (!item || !item.propriedade) return '';
      if (typeof item.propriedade === 'object') {
        return item.propriedade.pronome || '';
      }
      return String(item.propriedade);
    },

    $_getAtividade(item) {
      if (!item || !item.atividade) return '';
      if (typeof item.atividade === 'object') {
        return item.atividade.atadescricao || '';
      }
      return String(item.atividade);
    },

    $_getEventoNome(item) {
      if (!item || !item.evento) return '';
      if (typeof item.evento === 'object') {
        return item.evento.descricao || item.evento.text || item.evento.value || '';
      }
      return String(item.evento);
    },

    $_getOdometro(item) {
      if (item.odometro === undefined || item.odometro === null || item.odometro === '') return '';
      const tipo = item.tipoOdometro || 'KM';
      const num = Number(item.odometro);
      const valorFormatado = Number.isNaN(num) ? item.odometro : num.toLocaleString('pt-BR');
      return `${valorFormatado} ${tipo}`;
    },

    $_formataData(data) {
      if (!data) return '';
      return moment.tz(data, 'America/Sao_Paulo').local().format('DD/MM/YYYY HH:mm');
    },

    $_formataMoeda(valor) {
      if (valor === undefined || valor === null || valor === '') return '';
      const num = Number(valor);
      if (Number.isNaN(num)) return '';
      return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },

    $_novoFormulario() {
      sessionStorage.setItem(ROTA_STORAGE.cadastro, 'manutencao');
      sessionStorage.removeItem(MANUTENCAO_STORAGE.formulario);
      sessionStorage.removeItem(MANUTENCAO_STORAGE.itemSelecionado);
      this.$router.push({ name: 'manutencaoCadastro' });
    },

    async $_enviar(item) {
      const idLocal = item.idLocal || item.id;
      if (!idLocal) {
        errorHandler('Erro: ID local não encontrado para envio.');
        return;
      }

      this.enviandoId = idLocal;
      try {
        const conectou = await testarConexaoApi();
        if (!conectou) {
          errorHandler('Sem conexão com o servidor. A manutenção poderá ser enviada quando estiver online.');
          return;
        }

        // 1. Deletar apenas itens deletados desta manutenção
        await deletaItemMovimentacaoVeiculo(idLocal);

        // 2. Enviar apenas a manutenção clicada
        await enviaMovimentacaoVeiculo(idLocal);

        // 3. Enviar apenas os itens vinculados a esta manutenção
        await enviaItemMovimentacaoVeiculo(idLocal);

        const movAtualizada = await db.movimentacaoveiculo.get(Number(idLocal) || idLocal);
        if (movAtualizada && (movAtualizada.movdatanuvem || movAtualizada.movidnuvem || movAtualizada.enviado)) {
          // Marca no Dexie como enviado para não ser mais exibido na tela
          await db.movimentacaoveiculo.update(movAtualizada.id, {
            movenviado: 1,
            enviado: 1,
          });
          errorHandler('Manutenção enviada com sucesso!');
          await this.$_load();
        } else {
          errorHandler('Falha ao sincronizar manutenção com o servidor.');
        }
      } catch (err) {
        console.error('Erro ao enviar manutenção para a nuvem:', err);
        errorHandler('Erro ao enviar manutenção para a nuvem.');
      } finally {
        this.enviandoId = null;
      }
    },

    $_editar(item) {
      sessionStorage.setItem(ROTA_STORAGE.cadastro, 'manutencao');
      sessionStorage.removeItem(MANUTENCAO_STORAGE.formulario);
      sessionStorage.removeItem(MANUTENCAO_STORAGE.itemSelecionado);
      this.$router.push({
        name: 'manutencaoCadastro',
        query: { id: item.idLocal || item.id },
      });
    },

    async $_load() {
      this.loading = true;
      try {
        const movimentacoes = await db.movimentacaoveiculo.toArray();
        const veiculos = await db.veiculo.toArray();
        const pessoas = await db.pessoa.toArray();
        const propriedades = await db.propriedade.toArray();
        const eventos = await db.eventosveiculos.toArray();
        const atividades = db.veiculoatividade ? await db.veiculoatividade.toArray() : [];
        const itensMovimentacao = db.itemmovimentacaoveiculo ? await db.itemmovimentacaoveiculo.toArray() : [];
        const produtos = db.produto ? await db.produto.toArray() : [];

        const produtosPorId = new Map();
        const produtosPorDescricao = new Map();
        const produtosPorCodigo = new Map();
        produtos.forEach((p) => {
          const pId = p.proidproduto || p.id;
          if (pId != null) {
            produtosPorId.set(pId, p);
            produtosPorId.set(String(pId), p);
            const num = Number(pId);
            if (!Number.isNaN(num)) produtosPorId.set(num, p);
          }
          if (p.prodescricao) {
            produtosPorDescricao.set(p.prodescricao.trim().toLowerCase(), p);
          }
          if (p.procodigo) {
            produtosPorCodigo.set(String(p.procodigo).trim().toLowerCase(), p);
          }
        });
        const getProduto = (id, descricao = '') => {
          if (id != null && id !== '') {
            const num = Number(id);
            const valNum = !Number.isNaN(num) ? num : null;
            const res = produtosPorId.get(id)
              || (valNum !== null ? produtosPorId.get(valNum) : null)
              || produtosPorId.get(String(id));
            if (res) return res;
          }
          if (descricao) {
            const descLimpa = String(descricao).trim();
            const descLower = descLimpa.toLowerCase();
            if (produtosPorDescricao.has(descLower)) {
              return produtosPorDescricao.get(descLower);
            }
            if (descLimpa.includes(' - ')) {
              const partes = descLimpa.split(/\s*-\s*(.+)/);
              if (partes.length >= 2 && partes[0] && partes[1]) {
                const cod = partes[0].trim().toLowerCase();
                if (produtosPorCodigo.has(cod)) {
                  return produtosPorCodigo.get(cod);
                }
                const resto = partes[1].trim().toLowerCase();
                if (produtosPorDescricao.has(resto)) {
                  return produtosPorDescricao.get(resto);
                }
              }
            }
            const prodEncontrado = produtos.find((p) => {
              const pDesc = (p.prodescricao || '').trim().toLowerCase();
              return pDesc && (pDesc === descLower || descLower.includes(pDesc) || pDesc.includes(descLower));
            });
            if (prodEncontrado) return prodEncontrado;
          }
          return null;
        };

        const veiculosPorVeiId = new Map();
        const veiculosPorId = new Map();
        const veiculosPorPlaca = new Map();
        veiculos.forEach((v) => {
          if (v.veiidveiculo != null) {
            veiculosPorVeiId.set(v.veiidveiculo, v);
            veiculosPorVeiId.set(String(v.veiidveiculo), v);
            const num = Number(v.veiidveiculo);
            if (!Number.isNaN(num)) veiculosPorVeiId.set(num, v);
          }
          if (v.veiidnuvem != null) {
            veiculosPorVeiId.set(v.veiidnuvem, v);
            veiculosPorVeiId.set(String(v.veiidnuvem), v);
          }
          if (v.veiidveiculonuvem != null) {
            veiculosPorVeiId.set(v.veiidveiculonuvem, v);
            veiculosPorVeiId.set(String(v.veiidveiculonuvem), v);
          }
          if (v.id != null) {
            veiculosPorId.set(v.id, v);
            veiculosPorId.set(String(v.id), v);
            const num = Number(v.id);
            if (!Number.isNaN(num)) veiculosPorId.set(num, v);
          }
          const p = (v.veiplaca || v.placa || '').trim().toUpperCase();
          if (p) {
            veiculosPorPlaca.set(p, v);
          }
        });
        const getVeiculo = (id, placa = null) => {
          if (id != null && id !== '') {
            const num = Number(id);
            const valNum = !Number.isNaN(num) ? num : null;
            const res = veiculosPorVeiId.get(id)
              || (valNum !== null ? veiculosPorVeiId.get(valNum) : null)
              || veiculosPorVeiId.get(String(id))
              || veiculosPorId.get(id)
              || (valNum !== null ? veiculosPorId.get(valNum) : null)
              || veiculosPorId.get(String(id));
            if (res) return res;
          }
          if (placa) {
            const p = String(placa).trim().toUpperCase();
            if (veiculosPorPlaca.has(p)) return veiculosPorPlaca.get(p);
          }
          return null;
        };

        const pessoasPorPesId = new Map();
        const pessoasPorId = new Map();
        pessoas.forEach((p) => {
          if (p.pesidpessoa != null) {
            pessoasPorPesId.set(p.pesidpessoa, p);
            pessoasPorPesId.set(String(p.pesidpessoa), p);
            const num = Number(p.pesidpessoa);
            if (!Number.isNaN(num)) pessoasPorPesId.set(num, p);
          }
          if (p.id != null) {
            pessoasPorId.set(p.id, p);
            pessoasPorId.set(String(p.id), p);
            const num = Number(p.id);
            if (!Number.isNaN(num)) pessoasPorId.set(num, p);
          }
        });
        const getPessoa = (id) => {
          if (id == null || id === '') return null;
          const num = Number(id);
          const valNum = !Number.isNaN(num) ? num : null;
          return pessoasPorPesId.get(id)
            || (valNum !== null ? pessoasPorPesId.get(valNum) : null)
            || pessoasPorPesId.get(String(id))
            || pessoasPorId.get(id)
            || (valNum !== null ? pessoasPorId.get(valNum) : null)
            || pessoasPorId.get(String(id))
            || null;
        };

        const propriedadesPorProId = new Map();
        const propriedadesPorId = new Map();
        propriedades.forEach((pr) => {
          if (pr.proidpropriedade != null) {
            propriedadesPorProId.set(pr.proidpropriedade, pr);
            propriedadesPorProId.set(String(pr.proidpropriedade), pr);
            const num = Number(pr.proidpropriedade);
            if (!Number.isNaN(num)) propriedadesPorProId.set(num, pr);
          }
          if (pr.id != null) {
            propriedadesPorId.set(pr.id, pr);
            propriedadesPorId.set(String(pr.id), pr);
            const num = Number(pr.id);
            if (!Number.isNaN(num)) propriedadesPorId.set(num, pr);
          }
        });
        const getPropriedade = (id) => {
          if (id == null || id === '') return null;
          const num = Number(id);
          const valNum = !Number.isNaN(num) ? num : null;
          return propriedadesPorProId.get(id)
            || (valNum !== null ? propriedadesPorProId.get(valNum) : null)
            || propriedadesPorProId.get(String(id))
            || propriedadesPorId.get(id)
            || (valNum !== null ? propriedadesPorId.get(valNum) : null)
            || propriedadesPorId.get(String(id))
            || null;
        };

        const eventosPorEvvId = new Map();
        const eventosPorId = new Map();
        eventos.forEach((e) => {
          if (e.evvideventoveiculo != null) {
            eventosPorEvvId.set(e.evvideventoveiculo, e);
            eventosPorEvvId.set(String(e.evvideventoveiculo), e);
            const num = Number(e.evvideventoveiculo);
            if (!Number.isNaN(num)) eventosPorEvvId.set(num, e);
          }
          if (e.id != null) {
            eventosPorId.set(e.id, e);
            eventosPorId.set(String(e.id), e);
            const num = Number(e.id);
            if (!Number.isNaN(num)) eventosPorId.set(num, e);
          }
        });
        const getEvento = (id) => {
          if (id == null || id === '') return null;
          const num = Number(id);
          const valNum = !Number.isNaN(num) ? num : null;
          return eventosPorEvvId.get(id)
            || (valNum !== null ? eventosPorEvvId.get(valNum) : null)
            || eventosPorEvvId.get(String(id))
            || eventosPorId.get(id)
            || (valNum !== null ? eventosPorId.get(valNum) : null)
            || eventosPorId.get(String(id))
            || null;
        };

        const atividadesPorVeaId = new Map();
        const atividadesPorId = new Map();
        atividades.forEach((a) => {
          if (a.veaidveiculoatividade != null) {
            atividadesPorVeaId.set(a.veaidveiculoatividade, a);
            atividadesPorVeaId.set(String(a.veaidveiculoatividade), a);
            const num = Number(a.veaidveiculoatividade);
            if (!Number.isNaN(num)) atividadesPorVeaId.set(num, a);
          }
          if (a.id != null) {
            atividadesPorId.set(a.id, a);
            atividadesPorId.set(String(a.id), a);
            const num = Number(a.id);
            if (!Number.isNaN(num)) atividadesPorId.set(num, a);
          }
        });
        const getAtividade = (id) => {
          if (id == null || id === '') return null;
          const num = Number(id);
          const valNum = !Number.isNaN(num) ? num : null;
          return atividadesPorVeaId.get(id)
            || (valNum !== null ? atividadesPorVeaId.get(valNum) : null)
            || atividadesPorVeaId.get(String(id))
            || atividadesPorId.get(id)
            || (valNum !== null ? atividadesPorId.get(valNum) : null)
            || atividadesPorId.get(String(id))
            || null;
        };

        const itensDoDexie = movimentacoes
          .filter((m) => !m.movdeletar && !m.movenviado && !m.enviado)
          .sort((a, b) => new Date(b.movdata || b.movdataalteracao) - new Date(a.movdata || a.movdataalteracao))
          .map((m) => {
            const vei = getVeiculo(m.movidveiculo, m.veiplaca || m.placa);

            // Operador: prioriza movidoperador, depois movidpessoa, depois m.operador, depois movidfornecedor
            const idOp = m.movidoperador
              ?? m.movidpessoa
              ?? (typeof m.operador === 'number' ? m.operador : null)
              ?? (typeof m.operador === 'object' && m.operador !== null ? (m.operador.pesidpessoa || m.operador.id) : null)
              ?? m.movidfornecedor;

            const pes = getPessoa(idOp);

            const nomeOperador = (pes && pes.pesnome)
              || (typeof m.operador === 'string' && m.operador)
              || (typeof m.operador === 'object' && m.operador !== null && m.operador.pesnome)
              || m.pesnome
              || (pes ? pes.pesnomefantasia : '')
              || '';

            // Executor
            const idExec = m.movidpessoaexecutor
              ?? (typeof m.executor === 'number' ? m.executor : null)
              ?? (typeof m.executor === 'object' && m.executor !== null ? (m.executor.pesidpessoa || m.executor.id) : null);

            const exec = getPessoa(idExec);

            const nomeExecutor = (exec && exec.pesnome)
              || (typeof m.executor === 'string' && m.executor)
              || (typeof m.executor === 'object' && m.executor !== null && m.executor.pesnome)
              || (exec ? exec.pesnomefantasia : '')
              || '';

            let tipoManutencaoStr = '';
            const tipoM = String(m.movtipomanutencao || '').toUpperCase().trim();
            if (tipoM === 'E' || tipoM === '2' || tipoM === 'EXTERNA') {
              tipoManutencaoStr = 'Externa';
            } else if (tipoM === 'I' || tipoM === '1' || tipoM === 'INTERNA') {
              tipoManutencaoStr = 'Interna';
            }

            const pro = getPropriedade(m.movidpropriedade);
            const ev = getEvento(m.movideventoveiculo);
            const ata = getAtividade(m.movidatividade);

            let eventoDescricao = 'Manutenção';
            if (ev && ev.evvdescricao) {
              eventoDescricao = ev.evvdescricao;
            } else if (m.movideventoveiculo) {
              eventoDescricao = `Evento #${m.movideventoveiculo}`;
            }

            const itensDestaMov = itensMovimentacao.filter((it) => {
              if (it.imvdeletar) return false;
              const vinculo = it.imvidmovimentacaoveiculo;
              const vinculoNuvem = it.imvidmovimentacaonuvem;
              return (m.uuid && (vinculo === m.uuid || it.movimentacaouuid === m.uuid))
                || (m.id && (vinculo === m.id || Number(vinculo) === Number(m.id)))
                || (m.movidmovimentacaoveiculo && (vinculo === m.movidmovimentacaoveiculo || Number(vinculo) === Number(m.movidmovimentacaoveiculo)))
                || (m.movidnuvem && (vinculo === m.movidnuvem || vinculoNuvem === m.movidnuvem));
            }).map((it) => {
              const prodObj = getProduto(it.imvidproduto, it.imvdescricaoproduto);
              const descPura = this.$_obterNomeProduto(prodObj, it.imvdescricaoproduto) || prodObj?.prodescricao || it.imvdescricaoproduto || 'Peça / Item';
              let procodigo = String(prodObj?.procodigo || '').trim();
              if (!procodigo && it.imvdescricaoproduto && String(it.imvdescricaoproduto).includes(' - ')) {
                const partes = String(it.imvdescricaoproduto).split(/\s*-\s*(.+)/);
                if (partes.length >= 2 && partes[0]) {
                  procodigo = partes[0].trim();
                }
              }
              return {
                id: it.id,
                imvidproduto: it.imvidproduto || prodObj?.proidproduto || prodObj?.id || null,
                procodigo,
                produto: prodObj,
                tipo: (it.imvtipo === 'M' || it.imvtiposervico === 'M' || it.imvtiposervico === 2 || it.tipo === 'M' || it.tipo === 'M.O.') ? 'M.O.' : 'Peça',
                descricao: descPura,
                quantidade: it.imvquantidade || 1,
                unidade: it.imvunidadedemedida || prodObj?.proun || 'UN',
                valorUnitario: it.imvprecounitario,
                valorTotal: it.imvvalortotal,
                observacao: it.imvobservacao,
              };
            });

            const veifrota = (vei && vei.veifrota) || m.veifrota || '';
            const veiplaca = (vei && vei.veiplaca) || m.veiplaca || m.placa || '';
            const veimarca = (vei && vei.veimarca) || m.veimarca || '';

            return {
              id: m.movidmovimentacaoveiculo || m.id,
              movidmovimentacaoveiculo: m.movidmovimentacaoveiculo,
              idLocal: m.id,
              uuid: m.uuid || m.movuuid || null,
              movidnuvem: m.movidnuvem,
              sincronizado: !!m.movdatanuvem,
              dataHora: m.movdata,
              veiculo: vei,
              veifrota,
              veiplaca,
              veimarca,
              frota: veifrota,
              placa: veiplaca,
              marca: veimarca,
              evento: eventoDescricao,
              odometro: m.movvalortipo,
              tipoOdometro: m.movtipo || 'KM',
              operador: pes ? { ...pes, pesnome: nomeOperador } : nomeOperador,
              executor: exec ? { ...exec, pesnome: nomeExecutor } : nomeExecutor,
              tipoManutencao: tipoManutencaoStr,
              propriedade: pro ? pro.pronome : '',
              atividade: ata ? (ata.veadescricao || ata.atadescricao || ata.descricao) : (m.movidatividade || ''),
              observacao: m.movobservacao,
              garantia: m.movgarantiaate,
              itens: itensDestaMov,
            };
          });

        this.todosItens = itensDoDexie;
        this.$_aplicarFiltros();
      } catch (e) {
        console.warn('Erro ao carregar manutenções do Dexie:', e);
        this.todosItens = [];
        this.itens = [];
      } finally {
        this.loading = false;
      }
    },

    $_aplicarFiltros() {
      const storageFrom = sessionStorage.getItem(MANUTENCAO_STORAGE.createdFrom);
      const storageBefore = sessionStorage.getItem(MANUTENCAO_STORAGE.createdBefore);
      const storagePlaca = sessionStorage.getItem(MANUTENCAO_STORAGE.placa);

      const createdFrom = getQueryValue(MANUTENCAO_QUERIES.createdFrom, storageFrom || null);
      const createdBefore = getQueryValue(MANUTENCAO_QUERIES.createdBefore, storageBefore || null);
      const placa = getQueryValue(MANUTENCAO_QUERIES.placa, storagePlaca || null);

      let filtrados = this.todosItens || [];

      const getDataStr = (d) => {
        if (!d) return '';
        const m = moment(d);
        return m.isValid() ? m.format('YYYY-MM-DD') : String(d).slice(0, 10);
      };

      // 1. Filtro por Data Inicial (createdFrom)
      if (createdFrom) {
        filtrados = filtrados.filter((item) => {
          if (!item.dataHora) return false;
          return getDataStr(item.dataHora) >= createdFrom;
        });
      }

      // 2. Filtro por Data Final (createdBefore)
      if (createdBefore) {
        filtrados = filtrados.filter((item) => {
          if (!item.dataHora) return false;
          return getDataStr(item.dataHora) <= createdBefore;
        });
      }

      // 3. Filtro por Placa (ou Frota / Marca)
      if (placa && placa !== 'null' && placa !== 'undefined') {
        const pFiltro = String(placa).trim().toLowerCase();
        filtrados = filtrados.filter((item) => {
          const p = String(item.veiplaca || item.placa || (item.veiculo && item.veiculo.veiplaca) || '').toLowerCase();
          const f = String(item.veifrota || item.frota || (item.veiculo && item.veiculo.veifrota) || '').toLowerCase();
          const m = String(item.veimarca || item.marca || (item.veiculo && item.veiculo.veimarca) || '').toLowerCase();
          return p.includes(pFiltro) || f.includes(pFiltro) || m.includes(pFiltro);
        });
      }

      this.itens = filtrados;
    },

    $_limparFiltros() {
      const hoje = geraData(new Date(), 'YYYY-MM-DD');
      sessionStorage.setItem(MANUTENCAO_STORAGE.createdFrom, hoje);
      sessionStorage.setItem(MANUTENCAO_STORAGE.createdBefore, hoje);
      sessionStorage.removeItem(MANUTENCAO_STORAGE.placa);

      setQueryValue(MANUTENCAO_QUERIES.createdFrom, hoje);
      setQueryValue(MANUTENCAO_QUERIES.createdBefore, hoje);
      setQueryValue(MANUTENCAO_QUERIES.placa, null);
    },
  },

  watch: {
    $route: {
      deep: true,
      handler() {
        if (!this.todosItens || this.todosItens.length === 0) {
          this.$_load();
        } else {
          this.$_aplicarFiltros();
        }
      },
    },
  },

  created() {
    const hoje = geraData(new Date(), 'YYYY-MM-DD');
    const storageFrom = sessionStorage.getItem(MANUTENCAO_STORAGE.createdFrom);
    const storageBefore = sessionStorage.getItem(MANUTENCAO_STORAGE.createdBefore);
    const storagePlaca = sessionStorage.getItem(MANUTENCAO_STORAGE.placa);

    const from = getQueryValue(MANUTENCAO_QUERIES.createdFrom, storageFrom || hoje);
    const before = getQueryValue(MANUTENCAO_QUERIES.createdBefore, storageBefore || hoje);
    const placa = getQueryValue(MANUTENCAO_QUERIES.placa, storagePlaca || null);

    setQueryValue(MANUTENCAO_QUERIES.createdFrom, from);
    setQueryValue(MANUTENCAO_QUERIES.createdBefore, before);
    if (placa && placa !== 'null' && placa !== 'undefined') {
      setQueryValue(MANUTENCAO_QUERIES.placa, placa);
    }

    this.$_load();
  },
};
</script>

<style scoped>
.wrapper {
  width: 100%;
  padding-bottom: 20px;
}

.divnovo {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  width: 100%;
  margin: -12px 0 0 0;
  z-index: 3;
  background-color: #eeeeee;
  padding: 12px 0 12px 0;
}

@media screen and (min-width: 960px) {
  .divnovo {
    top: 64px;
  }
}

.botaoinferior {
  color: white !important;
  font-weight: bold;
}

.sem-registro {
  text-align: center;
  padding: 40px 16px;
}

.cards-container {
  margin-top: 80px;
  padding: 0 12px;
}

.card-manutencao {
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
  margin-bottom: 12px;
}

.card-header {
  padding: 12px 14px;
}

.item-id {
  font-size: 13px;
  color: #2e7d32;
}

.frota-titulo {
  font-size: 14px;
  color: #2c3e50;
}

.frota-placa {
  font-size: 12px;
  color: #546e7a;
  background-color: #eceff1;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 500;
}

.data-texto {
  font-size: 12px;
}

.card-detalhes {
  padding: 12px 14px;
  background-color: #fafafa;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-size: 13px;
  padding: 4px 0;
}

.info-label {
  font-weight: 600;
  color: #333333;
  min-width: 130px;
}

.info-valor {
  color: #212121;
  text-align: right;
  word-break: break-word;
}

.info-obs {
  flex-direction: column;
  align-items: flex-start;
  margin-top: 4px;
}

.obs-box {
  text-align: left;
  margin-top: 4px;
  white-space: pre-wrap;
  color: #424242;
  background-color: #f0f0f0;
  padding: 6px 10px;
  border-radius: 4px;
  width: 100%;
  font-size: 12px;
}

.itens-secao {
  width: 100%;
  border-top: 1px solid #757575;
  padding-top: 8px;
}

.itens-secao-header {
  font-size: 13px;
}

.itens-simplebar-scroll {
  max-height: 180px;
  background-color: #f5f5f5;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  padding: 6px 8px;
}

.itens-lista {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.item-peca-card {
  background-color: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 6px 10px;
}

.item-peca-desc {
  font-size: 12px;
  color: #333333;
  word-break: break-word;
}

.item-peca-qtd {
  font-size: 12px;
}

.itens-simplebar-scroll ::v-deep .simplebar-scrollbar::before {
  background-color: #9e9e9e;
  border-radius: 4px;
  opacity: 0.6;
}

.itens-simplebar-scroll ::v-deep .simplebar-track.simplebar-vertical {
  width: 7px;
}

.card-acoes {
  background-color: #ffffff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.btn-acao {
  height: 32px !important;
  font-size: 13px;
  border-radius: 6px;
}
</style>
